// src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

// Import Page Components
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ResourcesPage from "./pages/ResourcesPage";
import LoginPage from "./pages/LoginPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage"; // Newly added import
import DonationPage from "./pages/DonationPage"; 
import DashboardPage from "./pages/DashboardPage";
import ProfilePage from "./pages/ProfilePage";
import AddResourcePage from "./pages/AddResourcePage";
import EditResourcePage from "./pages/EditResourcePage";
import ManageCategoriesPage from "./pages/ManageCategoriesPage";
import SurveyPage from "./pages/SurveyPage"; 
import AssessmentPage from "./pages/AssessmentPage"; 

// Import Layout/Route Components
import LoggedInLayout from "./components/LoggedInLayout";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* --- Public Routes --- */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/donate" element={<DonationPage />} /> {/* New standalone public route */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} /> {/* New terms route */}
          <Route path="/survey" element={<SurveyPage />} /> 

          {/* --- Protected Routes --- */}
          {/* All routes that need the logged-in layout are now grouped under this single parent. */}
          <Route
            element={
              <ProtectedRoute>
                <LoggedInLayout />
              </ProtectedRoute>
            }
          >
            {/* Standard user routes */}
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/add-resources" element={<AddResourcePage />} />
            <Route path="/edit-resource/:id" element={<EditResourcePage />} />
            <Route path="/assessment" element={<AssessmentPage />} /> 
            
            {/* Admin-only route */}
            {/* The admin protection is now applied directly to the specific route element. */}
            <Route 
              path="/manage-categories" 
              element={
                <ProtectedRoute adminOnly={true}>
                  <ManageCategoriesPage />
                </ProtectedRoute>
              } 
            />
          </Route>
          
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;